"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OriIcon = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const OriIcon = (param)=>{
    let { color, name, size } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "icon v-icon-".concat(name),
        style: {
            fontSize: size,
            color
        }
    });
};
exports.OriIcon = OriIcon;
